var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('img',{staticClass:"icon",attrs:{"src":_vm.icon,"alt":""}}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),(_vm.isPass != null)?_c('div',{staticClass:"pass",domProps:{"innerHTML":_vm._s(_vm.pass)}}):_vm._e()]),_c('div',{staticClass:"content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }